<template>
  <v-form ref="editForm"
          @submit.prevent="saveContact">
    <v-card>
      <v-card-title class="pb-0">
        Edit Contact
      </v-card-title>
      <v-card-text>
        <user-contact-form :contact="contact"
                           :form="form"
                           @updated="contactUpdated">
        </user-contact-form>
      </v-card-text>
      <v-card-actions>
        <v-btn type="submit"
               color="primary"
               :disabled="contact.is_unsubscribed"
               @click.prevent="saveContact">
          Save
        </v-btn>
        <v-btn @click.prevent="cancel">
          Cancel
        </v-btn>
        <template v-if="team.unsubscribe_contacts_enabled">
          <v-spacer></v-spacer>
          <v-btn v-if="contact.is_subscribed"
                 type="button"
                 color="error"
                 @click.prevent="unsubscribeContact(contact)">
            Unsubscribe
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import {mapGetters} from 'vuex';
import {isObject} from "lodash";
import subscriberService from "../../../../../ml/services/subscriberService";
import {Form} from "vform";
import userContactService from "../../../services/userContactService";
import UserContactForm from "./UserContactForm";

export default {
  components: {UserContactForm},
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: new Form(userContactService.initForm(this.contact)),
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ])
  },
  methods: {
    saveContact() {
      if (this.contact.is_unsubscribed) { // MLD-2844
        this.$toast.error('You cannot edit an unsubscribed contact.');
        return;
      }
      this.form.put(`/api/user-contacts/${this.contact.id}`)
        .then(() => {
          this.$emit('updated')
          //this.closeContactForm();
        })
    },
    async unsubscribeContact(contact) { // MLD-2858
      if (isObject(contact) && contact.email) {
        if (!confirm('Are you sure you want to unsubscribe this email address? Nobody in your organization will be able to email them through Mobile Locker.')) {
          return;
        }
        try {
          let subscriber = await subscriberService.find(contact.email);
          if (!isObject(subscriber) || !subscriber.email) {
            subscriber = await subscriberService.create(contact.email);
          }
          if (subscriber) {
            const form = {
              subscriber_id: [subscriber.id],
            }
            subscriberService.unsubscribe(form)
              .then(() => {
                this.$emit('updated')
              })
              .catch(err => {

              })
          }
        } catch (e) {
          console.log('unsubsribeContact exception', e.message);
        }
      }
    },
    contactUpdated() { // MLD-2851
      this.$emit('updated');
    },
    cancel() {
      this.$emit('closed');
    }
  }
}
</script>
